import { render } from "./DataIbu.vue?vue&type=template&id=27b695bc"
import script from "./DataIbu.vue?vue&type=script&lang=js"
export * from "./DataIbu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__